import { theme } from '@theme';
import { SuccessToast } from '@utils/ToastUtils';
import { FC, useState } from 'react';
import { usePortfolioBulkActionsContainer } from '../../../../../hooks/UsePortfolioBulkActionsContainer';
import { BulkUpdateMarkInactiveResource } from '../../../../../types/PortfolioBulkActionResource';
import { PortfolioResource } from '../../../../../types/PortfolioResource';
import ButtonComponent from '../../../../shared/button/ButtonComponent';
import ConfirmationModal from '../../../../shared/modals/confirmation-modal/ConfirmationModal';
import { Typography } from '../../../../style';

type MarkInactiveProps = {
  selectedRecords: Array<PortfolioResource>;
  selectedRecordsCount: number;
  totalRecordsCount: number;
  isAllRowsSelected: boolean;
  isClearSelectionLink: boolean;
  toggleSelectedRows: (value: boolean) => void;
};

const MarkInactive: FC<MarkInactiveProps> = (props) => {
  const [isMarkInactiveModalOpen, setIsMarkInactiveModalOpen] = useState<boolean>(false);
  const { createMarkInactivePayload, bulkMarkInactiveDeals } = usePortfolioBulkActionsContainer();

  const openMarkInactiveModal = (): void => {
    setIsMarkInactiveModalOpen(true);
  };

  const handleCancel = () => {
    setIsMarkInactiveModalOpen(false);
  };

  const handleSubmit = (): void => {
    let payload: BulkUpdateMarkInactiveResource = createMarkInactivePayload(
      props.isAllRowsSelected,
      props.isClearSelectionLink,
      props.selectedRecords,
    );
    const successCallback = () => {
      props.toggleSelectedRows(false);
      if (props.isAllRowsSelected && props.isClearSelectionLink) {
        SuccessToast('Processing mark inactive deals');
      } else {
        SuccessToast('Successfully mark inactive ' + props.selectedRecordsCount + ' deals');
      }
    };

    setIsMarkInactiveModalOpen(false);

    bulkMarkInactiveDeals(payload, successCallback);
  };

  const bodyComponent: JSX.Element = (
    <>
      <Typography
        size={theme.typography.h4}
        display={'block'}
        fontWeight={theme.typography.fontWeights.semibold}
      >
        Are you sure you want to mark{' '}
        {props.isClearSelectionLink && props.isAllRowsSelected
          ? props.totalRecordsCount
          : props.selectedRecordsCount}{' '}
        selected deals as inactive?
      </Typography>
      <Typography size={theme.typography.h5} paddingTop={10} display={'block'}>
        Deals will no longer be visible.
      </Typography>
    </>
  );

  return (
    <>
      <ButtonComponent
        color={theme.palette.mediumGray}
        wrapperBackgroundColor={theme.palette.blackOlive}
        text={'Mark Inactive...'}
        fontWeight={theme.typography.fontWeights.semibold}
        outerPadding={'0px'}
        innerPadding={'7px 12px'}
        borderRadius={4}
        onClick={openMarkInactiveModal}
        textAlign='left'
      />
      <ConfirmationModal
        isOpen={isMarkInactiveModalOpen}
        handleSubmitClick={handleSubmit}
        handleCancelClick={handleCancel}
        cancelButtonText='Cancel'
        submitButtonText='Mark Inactive'
        title='Confirm Marking Inactive'
        bodyComponent={bodyComponent}
        showCloseIcon={false}
        padding={'20px 50px 20px 20px'}
        minHeight={'225px'}
      />
    </>
  );
};

export default MarkInactive;
